import React, { useEffect, useState }from 'react'
import { useHistory } from "react-router-dom";
import { HeaderOnlyLayout } from '../../layouts'
import { ChevronLeft } from 'react-feather'
import { Icon } from '@fluentui/react/lib/Icon'
import {
  BasicDropdown,
  Container,
  DateFilter,
  KhubMap,
  MobileFilter,
  MobileFilterButtons,
  MobileFilterButton,
  MobileFilterPanel,
} from '../../components'

// When integrate with backend, get this data from database
import programsDataNoHover from '../../components/khub-map/data/programs-dummy-data-no-hover'
// import programsDataNoZoom from '../../components/khub-map/data/programs-dummy-data-no-zoom'
import programsDataWithZoom from '../../components/khub-map/data/programs-dummy-data-with-zoom'
import auth from '../../utils/auth';

const options = [
  {label: 'NGO', value: 1},
  {label: 'CSO', value: 2},
  {label: 'Government', value: 3},
  {label: 'Donor', value: 4},
  {label: 'Corporate', value: 5},
]

const MapHeader = () => {
  const history = useHistory()
  const { isOfficial, isVerified } = auth()

  return (
    <Container className={`page-header ${isOfficial ? 'official' : isVerified ? 'verified' : ''} py-5 lg:py-3`} color="#f5f5f5">
      <div className="flex justify-between items-center">
        <div
          className="flex items-center cursor-pointer"
          onClick={() => history.go(-1)}
        >
          <ChevronLeft style={{width: '16px'}} className="mr-4"/>
          <div className="text-sm leading-none">Back to Program List</div>
        </div>
        <div className="hidden lg:flex items-center ">
          {/* <BasicDropdown
            placeholder="Organization"
            options={[]}
            noMargin
            className="mr-2"
          /> */}
          <div style={{minWidth: '160px'}}>
            <BasicDropdown
              options={options}
              multi
              noMarginBottom
              className="mr-2"
              placeholder="Organization"
            />
          </div>
          <div style={{minWidth: '160px'}}>
            <BasicDropdown
              placeholder="Approach"
              options={[]}
              noMargin
              className="mr-2"
              noMarginBottom
            />
          </div>
          <div style={{minWidth: '160px'}}>
            <BasicDropdown
              placeholder="Issues"
              options={[]}
              noMargin
              className="mr-2"
              noMarginBottom
            />
          </div>
          <div style={{minWidth: '160px'}}>
            <BasicDropdown
              placeholder="Province"
              options={[]}
              noMargin
              className="mr-2"
              noMarginBottom
            />
          </div>
          <div style={{minWidth: '160px'}} className="relative">
            {/* <BasicDropdown
              placeholder="Date"
              options={[]}
              noMargin
              className="mr-2"
              noMarginBottom
            /> */}
            <DateFilter />
          </div>
          <div
            className="underline text-sm ml-8 cursor-pointer"
            style={{minWidth: '94px', color: '#ccc'}}
          >
            Clear all filters
          </div>
        </div>
      </div>
    </Container>
  )
}

const ProgramMap = () => {
  const [mapData, setMapData] = useState([])
  const { isOfficial, isVerified } = auth()

  useEffect(() => {
    // Verified member and official member can zoom the map
    if (isVerified || isOfficial) {
      setMapData(programsDataWithZoom)
    } else {
      setMapData(programsDataNoHover)
    }
  }, [isOfficial, isVerified])

  return (
    <HeaderOnlyLayout>
      <MapHeader />
      <KhubMap data={mapData}>
        <div className="text-xs text-gray-500 py-5 lg:flex">
          <p className="mr-8">
            <span style={{marginRight: '5px', width: '10px', height: '10px', backgroundColor: '#52BAE2', display: 'inline-block', borderRadius: '50%'}} />
            231 results for completed programs
          </p>
          <p>
            <span style={{marginRight: '5px', width: '10px', height: '10px', backgroundColor: '#FF5448', display: 'inline-block', borderRadius: '50%'}}></span>
            3 results for ongoing programs
          </p>
        </div>
      </KhubMap>

      { /* Mobile Filter Button & Panel */ }
      <div className="lg:hidden">
        <MobileFilter>
          <MobileFilterButtons>
            <MobileFilterButton filterKey="filters">
              <div className="mr-2">
                <Icon iconName="Filter" className="ms-Filter text-xl" />
              </div>
              <div>Filter</div>
            </MobileFilterButton>
          </MobileFilterButtons>

          <MobileFilterPanel title="Filters" filterKey="filters">
            <div className="mb-8">
              <p className="font-bold text-sm mb-4">Organization</p>
              <BasicDropdown
                options={options}
                multi
                noMarginBottom
                className="mr-2"
                placeholder="Organization"
              />
            </div>
            <div className="mb-8">
              <p className="font-bold text-sm mb-4">Approach</p>
              <BasicDropdown
                options={[]}
                multi
                noMarginBottom
                className="mr-2"
                placeholder="Approach"
              />
            </div>
            <div className="mb-8">
              <p className="font-bold text-sm mb-4">Issues</p>
              <BasicDropdown
                options={[]}
                multi
                noMarginBottom
                className="mr-2"
                placeholder="Issues"
              />
            </div>
            <div className="mb-8">
              <p className="font-bold text-sm mb-4">Province</p>
              <BasicDropdown
                placeholder="Province"
                options={[]}
                noMargin
                className="mr-2"
                noMarginBottom
              />
            </div>
          </MobileFilterPanel>
        </MobileFilter>
      </div>
    </HeaderOnlyLayout>
  )
}

export { ProgramMap }
